export const DEFAULT_FORM_MODAL_WIDTH = 980;
export const DEFAULT_FORM_WITH_TABS_MODAL_WIDTH = 1015;
export const REFERENCE_TYPE_MENU_ITEM = 'FUNCTION_ITEM';
export const DEFAULT_THEME = 'default';

export enum EReferenceTypeMenuItemSectionCode {
    DIADOC_CODE= 'app.extlink-diadoc',
    EDISOFT_CODE = 'app.extlink-edisoft'
}
